import store from '@/store'

/**
 * 路由跳转工具类
 * <tian.xu96@qq.com>
 * */


let AuthUtil = {
  // 权限路由验证
  authRoute: (path) => {
    const access_path = store.getters.ROLES
    return !!access_path.includes(path)
  },
}

export default AuthUtil